import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const IMAGING_QUERY_KEY = "hrDocumentData";
export const DOCUMENTS_QUERY_KEY = "hrDocumentsData";
export const MEDIA_QUERY_KEY = "hrDocumentMediaData";

export const useHRImagingAndLabsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [IMAGING_QUERY_KEY, patientUserId],
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "hrapilabsimaging",
        path: `/documents/req/${patientUserId}`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return (await body?.json()) || {};
    },
    fetchPolicy: "network-only",
    placeholderData: {
      documentName: null,
      documentType: null,
      documentDate: null,
      description: null,
      active: 1,
    },
    enabled: !!patientUserId,
    select: (document) => {
      return {
        ...document,
        documentDate: document.documentDate?.replace(/-/g, "/") ?? "",
      };
    },
  });
};

export const useHRImagingAndLabsMediaQuery = (patientUserId) => {
  return useQuery({
    queryKey: [MEDIA_QUERY_KEY, patientUserId],
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "hrapilabsimaging",
        path: `/documents/medias/${patientUserId}`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
        fetchPolicy: "network-only",
      }).response;
      return (await body?.json()) || {};
    },
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useHRImagingAndLabsDocumentsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [DOCUMENTS_QUERY_KEY, patientUserId],
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "hrapilabsimaging",
        path: `/documents/list/${patientUserId}`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return (await body?.json()) || {};
    },
    retry: false,
    placeholderData: [],
    enabled: !!patientUserId,
  });
};
